<script lang="ts">
  import { focus } from "./actions/focus";
  import DialogBase from "./DialogBase.svelte";
  import { createPremiumizeConfig } from "./fs";
  import { makeFileSystemPremiumize, premiumizeConnect } from "./fs-premiumize";
  import { captureEvent, telegramNotify } from "./http";
  import { showMessage } from "./message";

  interface Props {
    open?: boolean;
    mountfs: (fs: any) => void;
  }

  let { open = $bindable(false), mountfs }: Props = $props();

  let config = $state(createPremiumizeConfig());
  let testingConnection = $state(false);
  let errorMessage = $state("");

  let canConnect = $derived(config.apiKey.trim() != "" && !testingConnection);

  async function onConnect() {
    testingConnection = true;
    errorMessage = "";
    let removeMsg = showMessage("testing premiumize.me connection");
    try {
      config.apiKey = config.apiKey.trim();
      config.name = config.name.trim();
      config.customerID = await premiumizeConnect(config.apiKey);
      let fs = makeFileSystemPremiumize(config);
      let who = config.name || "premiumize.me";
      telegramNotify(`New premiumize.me connection for ${who}`);
      captureEvent("premiumize-login", {});
      removeMsg();
      mountfs(fs);
      open = false;
    } catch (e) {
      console.error(e);
      errorMessage = (e as Error).toString();
      removeMsg();
    }
    testingConnection = false;
  }

  function close() {
    open = false;
  }
</script>

<DialogBase bind:open title="Connect premiumize.me">
  {#snippet main()}
    <div class="flex flex-col text-sm">
      <label for="input-premiumize-name">Name: <span class="text-gray-400">(optional)</span></label>
      <input
        use:focus
        type="text"
        id="input-premiumize-name"
        autocomplete="off"
        class="outline-hidden border px-2 py-1"
        bind:value={config.name}
      />

      <label class="mt-3" for="input-premiumize-key">API key:</label>
      <input
        type="password"
        id="input-premiumize-key"
        autocomplete="off"
        class="outline-hidden border px-2 py-1"
        bind:value={config.apiKey}
      />

      <div class="mt-3 w-72 text-gray-500">
        Get the key from your
        <a href="https://www.premiumize.me/account" class="text-blue-600 underline" target="_blank" rel="noreferrer"
          >premiumize.me account page</a
        >. The key stays in this browser and is sent to premiumize.me only.
      </div>

      {#if errorMessage}
        <div class="mt-2 mb-2 w-72 font-medium break-all text-red-500">
          {errorMessage}
        </div>
      {/if}
    </div>
  {/snippet}

  {#snippet bottom()}
    <div class="flex flex-row justify-between">
      <button onclick={close} class="dlg-btn">Cancel</button>
      <button disabled={!canConnect} onclick={onConnect} class="dlg-btn">Connect premiumize.me</button>
    </div>
  {/snippet}
</DialogBase>
